module.exports = "/shared/img/share.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/share.svg
// module id = 450
// module chunks = 13